// extracted by mini-css-extract-plugin
export var attachmentContainer = "_eh-0";
export var fileList = "_eh-2";
export var removeFileButton = "_eh-1";